import { SVGIllustrationRoot, __objRest, __spreadValues } from "./armor-illustrations-3YZCAMG6.js";

// src/components/SVGIllustration/SVGIllustration.tsx
import React from "react";
var SVGIllustration = function SVGIllustration(_a) {
  var _b = _a,
    children = _b.children,
    title = _b.title,
    viewBox = _b.viewBox,
    width = _b.width,
    height = _b.height,
    color = _b.color,
    restProps = __objRest(_b, ["children", "title", "viewBox", "width", "height", "color"]);
  return /* @__PURE__ */React.createElement(SVGIllustrationRoot, __spreadValues({
    viewBox: viewBox,
    focusable: "false",
    color: color,
    illustrationWidth: width,
    illustrationHeight: height
  }, restProps), !!title && /* @__PURE__ */React.createElement("title", null, title), children);
};
var SVGIllustrationGroup = function SVGIllustrationGroup(_ref) {
  var children = _ref.children;
  return /* @__PURE__ */React.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, children);
};
var SVGIllustrationPath = function SVGIllustrationPath(_ref2) {
  var d = _ref2.d,
    fill = _ref2.fill;
  return /* @__PURE__ */React.createElement("path", {
    d: d,
    fill: fill
  });
};
SVGIllustration.defaultProps = {
  display: "inline-block",
  viewBox: "0 0 50 50"
};
export { SVGIllustration, SVGIllustrationGroup, SVGIllustrationPath };